import React, { useState, useEffect, useCallback } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Auth from '../../Auth';
import { apiCallGet } from '../../../action/RouterActions';

const PatternsPartnerRedirectContainer = (props) => {
	const params = useParams();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation('translation', { keyPrefix: 'patternsPage' });
	const [error, setError] = useState('');

	const updatePartnerPortalRedirect = useCallback((payload) => {
		dispatch({ type: 'SET_PARTNER_PORTAL_REDIRECT', payload });
	}, [dispatch]);

	useEffect(() => {
		if (['vehiclescompany', 'company'].includes(params.page_type)) {
			// partner authorization
			new Auth().authenticateUser(true, 1, 1)
			// sets the PartnerPortalRedirect reducer
			updatePartnerPortalRedirect({
				type: params.page_type,
				id: params.company_id,
				company_id: params.company_id,
				portal_url: document.referrer,
			})
			// redirect to Homepage
			navigate('/', {
				state: undefined,
			});
		}
		else if (params.page_type === 'vehicle') {
			// partner authorization
			new Auth().authenticateUser(true, 1, 1)
			// sets the PartnerPortalRedirect reducer
			updatePartnerPortalRedirect({
				type: params.page_type,
				id: params.id,
				company_id: params.company_id,
				portal_url: document.referrer,
			})
			// redirect to Vehicle Edit page
			navigate('/managevehicles/edit', {
				state: {
					id: params.id,
				},
			});
		}
		else if (params.page_type === 'profile') {
			apiCallGet('/company/{company_id}', { company_id: params.company_id })
				.then((res) => {
					const { company } = res.data.response
					// partner authorization
					new Auth().authenticateUser(true, 1, 1)
					// sets the PartnerPortalRedirect reducer
					updatePartnerPortalRedirect({
						type: params.page_type,
						id: params.id,
						company_id: params.company_id,
						portal_url: document.referrer,
					})
					// redirect to Vehicle Edit page
					navigate('/managevehicles', {
						state: {
							tabKey: 2,
							profile_name: params.id,
							device_id: 'all',
							company,
						},
					});
				})
				.catch((err) => {
					setError(true)
					console.log('!getCompanyById for profile error: ', err.response, err)
				})
		}

		if (!new Auth().isUserAuthenticated() && params.token) {
			new Auth().authenticateUser(true, params.token, 1);
		}
	}, []);

	return (
		<article>
			{error
				&& (
					<div>
						<h3>{t('error404')}</h3>
						<div>{error}</div>
						<div>
							{t('goBack')} <Link to="/" className="btn">{t('btnHome')}</Link>
						</div>
					</div>
				)}
		</article>
	)
}

export default PatternsPartnerRedirectContainer;
